import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAccount } from '../../contexts/AccountContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute - Wrapper for routes that require authentication
 *
 * TASK-086: Enhanced to use AccountContext instead of direct localStorage access
 *
 * Uses AccountContext to check authentication state and redirects to login
 * if user is not authenticated. Preserves the intended destination for
 * post-login redirect.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, account } = useAccount();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect to login if not authenticated
    if (!isAuthenticated) {
      console.log('[ProtectedRoute] Not authenticated, redirecting to /login');
      navigate('/login', {
        state: { from: location.pathname + location.search }, // Preserve intended destination with query params
        replace: true, // Prevent back-button loop
      });
    }
  }, [isAuthenticated, navigate, location]);

  // Show nothing while checking authentication or redirecting
  if (!isAuthenticated || !account) {
    return null;
  }

  // Render protected content
  return <>{children}</>;
};

export default ProtectedRoute;
